module.exports = __webpack_public_path__ + "media/images/brands/tigor_t_tigre-7988b4401cc19a2c020d2965d7f5c9f0.png";